import { Navigate, Route } from "react-router";
import { all_routes } from "./all_routes";
import NfOrganisations from "../Nestfin/organisations";
import LeadAccActivity from "../Nestfin/lead-account-activity";
import LeadAccProfile from "../Nestfin/lead-account-profile";
import PmsTenantBooking from "../Nestfin/pms-tenant-booking";
import PmsTicket from "../Nestfin/pms-ticket";
import PmsTicketAttachment from "../Nestfin/pms-ticket-attachment";
import OrgProperties from "../Nestfin/Properties";
import ViewStaff from "../Nestfin/ViewStaff";
import AllBookings from "../Nestfin/Bookings";
import Login from "../auth/login/login";
import Register from "../auth/register/register";
import TwoStepVerification from "../auth/twoStepVerification/twoStepVerification";
import EmailVerification from "../auth/emailVerification/emailVerification";
import ResetPassword from "../auth/resetPassword/resetPassword";
import ForgotPassword from "../auth/forgotPassword/forgotPassword";
import Error404 from "../pages/error/error-404";
import Error500 from "../pages/error/error-500";
import UnderMaintenance from "../pages/underMaintenance";
import UnderConstruction from "../pages/underConstruction";
import LockScreen from "../auth/lockScreen";
import ResetPasswordSuccess from "../auth/resetPasswordSuccess/resetPasswordSuccess";

import ComingSoon from "../pages/comingSoon";
import AdminDashboard from "../admin/adminDashboard";
import EmployeeDashboard from "../mainMenu/employeeDashboard/employee-dashboard";
import LeadsDasboard from "../mainMenu/leadsDashboard";
import DealsDashboard from "../mainMenu/dealsDashboard";
import LeadsList from "../crm/leads/leadsList";
import BookingReconciliation from "../crm/leads/BookingReconciliation";
import UploadBulkLeads from "../crm/leads/UploadBulkLeads";
import SalesTeam from "../crm/leads/SalesTeam";
import FollowUpTrails from "../crm/leads/FollowUpTrails";
import SalesPersonLeadList from "../crm/leads/SalesPersonLeadList";
import AddStaff from "../crm/leads/AddStaff";
import PropertyList from "../crm/organizationDetails/PropertyList";
import StaffList from "../crm/organizationDetails/StaffList";
import AdminList from "../crm/organizationDetails/AdminList";
import TenantList from "../crm/organizationDetails/TenantList";
import ManageSalesGroup from "../crm/groupManagement/ManageSalesGroup";
import CreateGroupPage from "../crm/groupManagement/CreateGroupPage";
import EditGroupPage from "../crm/groupManagement/EditGroupPage";
import { elements } from "chart.js";
import ViewGroupMemebers from "../crm/groupManagement/ViewMember";
import ViewMemberActivities from "../crm/groupManagement/ViemMemberActivities";

const routes = all_routes;

export const publicRoutes = [
  {
    path: "/",
    name: "Root",
    element: <AdminDashboard />,
    route: Route,
  },
  {
    path: routes.adminDashboard,
    element: <AdminDashboard />,
    route: Route,
  },
  {
    path: routes.employeeDashboard,
    element: <EmployeeDashboard />,
    route: Route,
  },
  {
    path: routes.leadsDashboard,
    element: <LeadsDasboard />,
    route: Route,
  },
  {
    path: routes.dealsDashboard,
    element: <DealsDashboard />,
    route: Route,
  },
  {
    path: routes.LeadsList,
    element: <LeadsList />,
    route: Route,
  },
  {
    path: routes.bookingreconciliation,
    element: <BookingReconciliation />,
    route: Route,
  },
  {
    path: routes.uploadbulkleads,
    element: <UploadBulkLeads />,
    route: Route,
  },
  {
    path: routes.salesTeam,
    element: <SalesTeam />,
    route: Route,
  },
  {
    path: routes.FollowUpTrail,
    element: <FollowUpTrails/>,
    route: Route,
  },
  {
    path: routes.SalesPersonLeadList,
    element: <SalesPersonLeadList/>,
    route: Route,
  },
  // {
  //   path: routes.AddStaff,
  //   element: <AddStaff/>,
  //   route: Route,
  // },


  // ======== Main NESTFIN ======== //
  {
    path: routes.AllOrganizations,
    element: <NfOrganisations />,
    route: Route,
  },
  // {
  //   path: routes.GetPropertyDetails,
  //   element: <OrgProperties />,
  //   route: Route,
  // },
  {
    path: routes.GetPropertyDetails,
    element: <PropertyList />,
    route: Route,
  },

  {
    path: routes.GetStaffDetails,
    element: <StaffList />,
    route: Route,
  },
  {
    path: routes.AdminDetails,
    element: <AdminList />,
    route: Route,
  },
  {
    path: routes.TenantDetails,
    element: <TenantList />,
    route: Route,
  },
  {
    path: routes.GetBooking,
    element: <AllBookings />,
    route: Route,
  },

  // ======== Main NESTFIN ======== //


  // ------------------------------------------------------------------------------------


  // ======== NESTFIN ======== //
  {
    path: routes.leadAccProfile,
    element: <LeadAccProfile />,
    route: Route,
  },
  {
    path: routes.leadAccActivity,
    element: <LeadAccActivity />,
    route: Route,
  },
  {
    path: routes.pmsTenantBooking,
    element: <PmsTenantBooking />,
    route: Route,
  },
  {
    path: routes.pmsTicket,
    element: <PmsTicket />,
    route: Route,
  },
  {
    path: routes.pmsTicketAttachment,
    element: <PmsTicketAttachment />,
    route: Route,
  },
  {
    path: routes.leaddashboard,
    element: <LeadsDasboard />,
    route: Route,
  },
  {
    path: routes.leadsList,
    element: <LeadsList />,
    route: Route,
  },
  {
    path: routes.bookingReconciliation,
    element: <BookingReconciliation />,
    route: Route,
  },
  // ======== NESTFIN ======== //
  {
    path: routes.ManageSalesGroup,
    element: <ManageSalesGroup />,
    route: Route,
  },
    {
    path: routes.CreateGroupPage,
    element: <CreateGroupPage />,
    route: Route,
  },
    {
    path: routes.EditGroupPage,
    element: <EditGroupPage />,
    route: Route,
  },
  {
    path: routes.ViewGroupMembers,
    element: <ViewGroupMemebers/>,
    route: Route,
  },
  {
    path: routes.ViewGroupMemberActivities,
    element: <ViewMemberActivities/>,
    route: Route,
  },
  {
    path: routes.ViewLeadList,
    element: <LeadsList/>,
    route: Route,
  },


];

export const authRoutes = [
  {
    path: routes.comingSoon,
    element: <ComingSoon />,
    route: Route,
  },
  {
    path: routes.login,
    element: <Login />,
    route: Route,
  },
  {
    path: routes.register,
    element: <Register />,
    route: Route,
  },
  {
    path: routes.twoStepVerification,
    element: <TwoStepVerification />,
    route: Route,
  },
  {
    path: routes.emailVerification,
    element: <EmailVerification />,
    route: Route,
  },
  {
    path: routes.register,
    element: <Register />,
    route: Route,
  },
  {
    path: routes.resetPassword,
    element: <ResetPassword />,
    route: Route,
  },
  {
    path: routes.forgotPassword,
    element: <ForgotPassword />,
    route: Route,
  },
  {
    path: routes.error404,
    element: <Error404 />,
    route: Route,
  },
  {
    path: routes.error500,
    element: <Error500 />,
    route: Route,
  },
  {
    path: routes.underMaintenance,
    element: <UnderMaintenance />,
    route: Route,
  },
  {
    path: routes.underConstruction,
    element: <UnderConstruction />,
  },
  {
    path: routes.lockScreen,
    element: <LockScreen />,
  },
  {
    path: routes.resetPasswordSuccess,
    element: <ResetPasswordSuccess />,
  },
];
